<div class="account-pages my-5 pt-sm-5">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Free Register</h5>
                  <p>Get your HESLB account now.</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img src="assets/images/profile-img.png" alt="" class="img-fluid">
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <a routerLink="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="assets/images/logo.png" alt="" class="rounded-circle" height="34">
                  </span>
                </div>
              </a>
            </div>
            <div class="p-2">

              <form class="needs-validation" name="signupForm" [formGroup]="signupForm" (ngSubmit)="onSubmit(signupForm.value)"
                novalidate>

                <ngb-alert type="success" *ngIf="successmsg" [dismissible]="false">Registration successful.
                </ngb-alert>

                <ngb-alert type="danger" *ngIf="error" [dismissible]="false">{{ error }}</ngb-alert>

                <div class="mb-3">
                  <label class="col-form-label" for="regType">What is Your Sign-Up Type ?</label>

                  <select class="form-select" id="regType" formControlName="regType" (change)="changeRegistrationType($event)"
                          [ngClass]="{ 'is-invalid': (f.regType.dirty || f.regType.touched ) && f.regType.errors }"
                  >
                    <option value="beneficiary">Loan Details</option>
                    <option value="beneficiary">Loan Repayment</option>
                    <option value="refundApplication">Refund Application</option>
                  </select>
                  <div *ngIf="(f.regType.dirty || f.regType.touched) && f.regType.errors" class="invalid-feedback">
                    <div *ngIf="f.regType?.errors?.required">Please Select Your Account Creation Category.</div>
                  </div>
                </div>

                <ng-container *ngIf="showBenefForm">
                  <div class="mb-3">
                    <label for="refundIndexNo" class="form-label">Form 4 Index Number</label>

                    <input type="text" formControlName="benefIndexNo" class="form-control"
                           (change)="onChangeBenefIndexNo()"
                           [ngClass]="{ 'is-invalid': (f.benefIndexNo.dirty || f.benefIndexNo.touched) && f.benefIndexNo.errors }" id="benefIndexNo"
                           placeholder="Enter Form 4 Index Number" />
                    <div *ngIf="(f.benefIndexNo.dirty || f.benefIndexNo.touched) && f.benefIndexNo.errors" class="invalid-feedback">
                      <div *ngIf="f.benefIndexNo?.errors?.required">Index Number is required</div>
                      <div *ngIf="f.benefIndexNo?.errors?.isValidIndexNo">Please Enter A Valid Index Number</div>
                    </div>
                    <div *ngIf="indexDetails" class="row text-center p-1"><span class="text-success">{{indexDetails?.first_name}} {{indexDetails?.middle_name}} {{indexDetails?.last_name}}</span></div>
                  </div>
                  <div *ngIf="showUseAdvanceSeach" class="row text-center mt-1"><p>You Are Beneficiary ? <a routerLink="/account/benef-advanced-search" class="fw-medium text-primary"> Please Use Our Advanced Search</a></div>
                </ng-container>
                <ng-container *ngIf="showRefundForm">
                  <div class="mb-3">
                    <label class="col-form-label" for="hasf4Index">Do You Have A Form 4 Index Number</label>

                    <select class="form-select" id="hasf4Index" formControlName="hasf4Index" (change)="changeHasIndexNo($event)"
                            [ngClass]="{ 'is-invalid': (f.hasf4Index.dirty || f.hasf4Index.touched ) && f.hasf4Index.errors }"
                    >
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                    <div *ngIf="(f.hasf4Index.dirty || f.hasf4Index.touched) && f.hasf4Index.errors" class="invalid-feedback">
                      <div *ngIf="f.hasf4Index?.errors?.required">Please Select if You Have A Form 4 IndexNumber or Not.</div>
                    </div>
                  </div>
                  <ng-container *ngIf="hasIndexNo == 1">
                    <div class="mb-3">
                      <label for="refundIndexNo" class="form-label">Form 4 Index Number Refund</label>

                      <input type="text" formControlName="refundIndexNo" class="form-control"
                             (change)="onChangeRefundIndexNo()"
                             [ngClass]="{ 'is-invalid': (f.refundIndexNo.dirty || f.refundIndexNo.touched) && f.refundIndexNo.errors }" id="refundIndexNo"
                             placeholder="Enter Form 4 Index Number" />
                      <div *ngIf="(f.refundIndexNo.dirty || f.refundIndexNo.touched) && f.refundIndexNo.errors" class="invalid-feedback">
                        <div *ngIf="f.refundIndexNo?.errors?.required">Index Number is required</div>
                        <div *ngIf="f.refundIndexNo?.errors?.isValidIndexNo">Please Enter A Valid Index Number</div>
                      </div>
                      <div *ngIf="refundIndexDetails" class="row text-center p-1"><span class="text-success">{{refundIndexDetails?.first_name}} {{refundIndexDetails?.middle_name}} {{refundIndexDetails?.last_name}}</span></div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="hasIndexNo == 0">
                    <div class="mb-3">
                      <label for="firstName" class="form-label">First Name</label>

                      <input type="text" formControlName="firstName" class="form-control"
                             [ngClass]="{ 'is-invalid': (f.firstName.dirty || f.firstName.touched) && f.firstName.errors }" id="firstName"
                             placeholder="Enter Your First Name" />
                      <div *ngIf="(f.firstName.dirty || f.firstName.touched) && f.firstName.errors" class="invalid-feedback">
                        <div *ngIf="f.firstName?.errors?.required">Fist Name is required</div>
                      </div>
                    </div>
                    <div class="mb-3">
                      <label for="middleName" class="form-label">Middle Name</label>

                      <input type="text" formControlName="middleName" class="form-control"
                             [ngClass]="{ 'is-invalid': (f.middleName.dirty || f.middleName.touched) && f.middleName.errors }" id="middleName"
                             placeholder="Enter Your Middle" />
                      <div *ngIf="(f.middleName.dirty || f.middleName.touched) && f.middleName.errors" class="invalid-feedback">
                        <div *ngIf="f.middleName?.errors?.required">Middle Name is required</div>
                      </div>
                    </div>
                    <div class="mb-3">
                      <label for="lastName" class="form-label">Last Name</label>

                      <input type="text" formControlName="lastName" class="form-control"
                             [ngClass]="{ 'is-invalid': (f.lastName.dirty || f.lastName.touched) && f.lastName.errors }" id="lastName"
                             placeholder="Enter Your Last Name" />
                      <div *ngIf="(f.lastName.dirty || f.lastName.touched) && f.lastName.errors" class="invalid-feedback">
                        <div *ngIf="f.lastName?.errors?.required">Last Name is required</div>
                      </div>
                    </div>
                    <div class="mb-3">
                      <label class="col-form-label" for="regType">Gender</label>

                      <select class="form-select" id="sex" formControlName="sex"
                              [ngClass]="{ 'is-invalid': (f.sex.dirty || f.sex.touched ) && f.sex.errors }"
                      >
                        <option value="M">Male</option>
                        <option value="F">Female</option>
                      </select>
                      <div *ngIf="(f.sex.dirty || f.sex.touched) && f.sex.errors" class="invalid-feedback">
                        <div *ngIf="f.sex?.errors?.required">Please Select Your Gender.</div>
                      </div>
                    </div>
                  </ng-container>

                </ng-container>
                <ng-container *ngIf="showEmailPassword">
                  <div class="mb-3">
                    <label for="email" class="form-label">Email</label>

                    <input type="email" formControlName="email" class="form-control"
                           [ngClass]="{ 'is-invalid': (f.email.dirty || f.email.touched) && f.email.errors }" id="email" placeholder="Email" />

                    <div *ngIf="(f.email.dirty || f.email.touched) && f.email.errors" class="invalid-feedback">
                      <div *ngIf="f.email?.errors?.required">Email is required</div>
                      <div *ngIf="f.email?.errors?.email">Email must be a valid email address</div>
                    </div>
                  </div>
                  <div class="mb-3">
                    <label for="phone" class="form-label">Phone Number</label>

                    <input type="text" formControlName="phone" class="form-control"
                           [ngClass]="{ 'is-invalid': (f.phone.dirty || f.phone.touched) && f.phone.errors }" id="phone" placeholder="Phone Number" />
                    <div *ngIf="(f.phone.dirty || f.phone.touched) && f.phone.errors" class="invalid-feedback">
                      <div *ngIf="f.phone.errors.required">Phone Number Is Required</div>
                      <div *ngIf="f.phone.errors.isValidPhoneNumber">A Valid Tz Phone Number Is Required</div>
                    </div>
                  </div>

                  <div class="mb-3">
                    <label for="password" class="form-label">Password</label>

                    <input type="password" formControlName="password" class="form-control"
                           [ngClass]="{ 'is-invalid': submitted && f.password.errors }" id="password" placeholder="Password" />

                    <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                      <div *ngIf="f.password.errors.required">Password is required</div>
                    </div>
                  </div>
                </ng-container>

                <div class="mt-4 d-grid">
                  <button [disabled]="signupForm.invalid" [ladda]="loadingSubmit"
                          class="btn btn-primary" type="submit">Register
                  </button>
                  <div *ngIf="registeredBenef" class="row text-center p-1"><span class="text-success">You Have Been Registered With The User-Name: {{registeredBenef?.index_no}}</span></div>
                  <!--                  <button class="btn btn-primary" type="submit">Register</button>-->
                </div>
                <div class="mt-4 text-center">
                  <p class="mb-0">By registering you agree to the HESLB <a href="javascript: void(0);"
                      class="text-primary">Terms of
                      Use</a></p>
                </div>
              </form>
            </div>
          </div>
        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
          <p>Already have an account ? <a routerLink="/account/login" class="fw-medium text-primary"> Login</a>
          </p>
          <p>© {{year}} HESLB.</p>
        </div>
      </div> <!-- end col -->
    </div>
    <!-- end row -->
  </div>
  <!-- end container -->
</div>
